"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prepareQueryGetChecklistSettings = void 0;
const prepareQueryGetChecklistSettings = ({ memberId, }) => `
  query CurrentSettings {
    currentSettings(memberId: ${memberId}) {
        id
        value
    }
  }
`;
exports.prepareQueryGetChecklistSettings = prepareQueryGetChecklistSettings;
//# sourceMappingURL=getChecklistSettings.js.map